<highcharts-chart [Highcharts]="highcharts" [options]="splinChartOptions"
  style="width: 100%; display: block;
  position: relative;
  right: 15px;">
</highcharts-chart>